/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DeleteDistributorSuccessResponse,
    DeleteDistributorSuccessResponseFromJSON,
    DeleteDistributorSuccessResponseToJSON,
    Distributor400Error,
    Distributor400ErrorFromJSON,
    Distributor400ErrorToJSON,
    Distributor401Error,
    Distributor401ErrorFromJSON,
    Distributor401ErrorToJSON,
    Distributor404Error,
    Distributor404ErrorFromJSON,
    Distributor404ErrorToJSON,
    Distributor500Error,
    Distributor500ErrorFromJSON,
    Distributor500ErrorToJSON,
    DistributorImage400Error,
    DistributorImage400ErrorFromJSON,
    DistributorImage400ErrorToJSON,
    GetDistributorDetailSuccessResponse,
    GetDistributorDetailSuccessResponseFromJSON,
    GetDistributorDetailSuccessResponseToJSON,
    GetDistributorsSuccessResponse,
    GetDistributorsSuccessResponseFromJSON,
    GetDistributorsSuccessResponseToJSON,
    PostDistributorImageSuccessResponse,
    PostDistributorImageSuccessResponseFromJSON,
    PostDistributorImageSuccessResponseToJSON,
    PostDistributorRequestBody,
    PostDistributorRequestBodyFromJSON,
    PostDistributorRequestBodyToJSON,
    PostDistributorSuccessResponse,
    PostDistributorSuccessResponseFromJSON,
    PostDistributorSuccessResponseToJSON,
    PutDistributorRequestBody,
    PutDistributorRequestBodyFromJSON,
    PutDistributorRequestBodyToJSON,
    PutDistributorSuccessResponse,
    PutDistributorSuccessResponseFromJSON,
    PutDistributorSuccessResponseToJSON,
} from '../models';

export interface DistributorsIdDeleteRequest {
    id: number;
}

export interface DistributorsIdGetRequest {
    id: number;
}

export interface DistributorsIdPutRequest {
    id: number;
    putDistributorRequestBody?: PutDistributorRequestBody;
}

export interface DistributorsImagePostRequest {
    image: Blob;
}

export interface DistributorsPostRequest {
    postDistributorRequestBody?: PostDistributorRequestBody;
}

/**
 * 
 */
export class PressReleaseDistributorApi extends runtime.BaseAPI {

    /**
     * 配信者情報のリストを取得するAPI
     * GetPressReleaseDistributorsList
     */
    async distributorsGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetDistributorsSuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/distributors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDistributorsSuccessResponseFromJSON(jsonValue));
    }

    /**
     * 配信者情報のリストを取得するAPI
     * GetPressReleaseDistributorsList
     */
    async distributorsGet(initOverrides?: RequestInit): Promise<GetDistributorsSuccessResponse> {
        const response = await this.distributorsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 配信者情報を削除するAPI
     * DeletePressReleaseDistributor
     */
    async distributorsIdDeleteRaw(requestParameters: DistributorsIdDeleteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DeleteDistributorSuccessResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling distributorsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/distributors/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteDistributorSuccessResponseFromJSON(jsonValue));
    }

    /**
     * 配信者情報を削除するAPI
     * DeletePressReleaseDistributor
     */
    async distributorsIdDelete(requestParameters: DistributorsIdDeleteRequest, initOverrides?: RequestInit): Promise<DeleteDistributorSuccessResponse> {
        const response = await this.distributorsIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 配信者情報の詳細を取得するAPI
     * GetPressReleaseDistributorDetail
     */
    async distributorsIdGetRaw(requestParameters: DistributorsIdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetDistributorDetailSuccessResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling distributorsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/distributors/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDistributorDetailSuccessResponseFromJSON(jsonValue));
    }

    /**
     * 配信者情報の詳細を取得するAPI
     * GetPressReleaseDistributorDetail
     */
    async distributorsIdGet(requestParameters: DistributorsIdGetRequest, initOverrides?: RequestInit): Promise<GetDistributorDetailSuccessResponse> {
        const response = await this.distributorsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 配信者情報を更新するAPI
     * UpdatePressReleaseDistributor
     */
    async distributorsIdPutRaw(requestParameters: DistributorsIdPutRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PutDistributorSuccessResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling distributorsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/distributors/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PutDistributorRequestBodyToJSON(requestParameters.putDistributorRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PutDistributorSuccessResponseFromJSON(jsonValue));
    }

    /**
     * 配信者情報を更新するAPI
     * UpdatePressReleaseDistributor
     */
    async distributorsIdPut(requestParameters: DistributorsIdPutRequest, initOverrides?: RequestInit): Promise<PutDistributorSuccessResponse> {
        const response = await this.distributorsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 配信者 (会社) ロゴ画像をアップロードするAPI
     * PressReleaseDistributorImageUpload
     */
    async distributorsImagePostRaw(requestParameters: DistributorsImagePostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostDistributorImageSuccessResponse>> {
        if (requestParameters.image === null || requestParameters.image === undefined) {
            throw new runtime.RequiredError('image','Required parameter requestParameters.image was null or undefined when calling distributorsImagePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.image !== undefined) {
            formParams.append('image', requestParameters.image as any);
        }

        const response = await this.request({
            path: `/distributors/image`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostDistributorImageSuccessResponseFromJSON(jsonValue));
    }

    /**
     * 配信者 (会社) ロゴ画像をアップロードするAPI
     * PressReleaseDistributorImageUpload
     */
    async distributorsImagePost(requestParameters: DistributorsImagePostRequest, initOverrides?: RequestInit): Promise<PostDistributorImageSuccessResponse> {
        const response = await this.distributorsImagePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 配信者情報を作成するAPI
     * CreatePressReleaseDistributor
     */
    async distributorsPostRaw(requestParameters: DistributorsPostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostDistributorSuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/distributors`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostDistributorRequestBodyToJSON(requestParameters.postDistributorRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostDistributorSuccessResponseFromJSON(jsonValue));
    }

    /**
     * 配信者情報を作成するAPI
     * CreatePressReleaseDistributor
     */
    async distributorsPost(requestParameters: DistributorsPostRequest = {}, initOverrides?: RequestInit): Promise<PostDistributorSuccessResponse> {
        const response = await this.distributorsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
